import { nodeConfig } from '@/mixins';
import { settings } from '@/helpers/config';
import modalFactory from '@/modules/modal';

const NAMESPACE = 'alert';
const DEFAULT_SELECTOR = '[data-js-alert-wrapper]';
const DEFAULT_SETTINGS = {
	localStorage: {
		key: `${settings.namespace}-${NAMESPACE}`
	}
};

class Alert {
	/** @param {HTMLElement} node */
	constructor(node, config) {
		this.elNode = node;
		this.config = config;
	}

	get storage() {
		return window.localStorage;
	}

	get storageValue() {
		return this.storage.getItem(this.config.localStorage.key);
	}

	get ajaxURL() {
		return window?.AlertURL;
	}

	/** @returns {?HTMLElement} */
	get elAlert() {
		return this.elNode.querySelector('[data-js-alert]');
	}

	get time() {
		return this.elAlert?.dataset.time || '';
	}

	/** @returns {?HTMLElement} */
	get elCloseButton() {
		return this.elAlert?.querySelector('[data-js-alert-close-button]');
	}

	async fetchMarkupViaAjax(cb) {
		const alertResponse = await fetch(this.ajaxURL);

		if (!alertResponse.ok) return;

		const alertHTML = await alertResponse.text();
		const parser = new DOMParser();
		const alertDoc = parser.parseFromString(alertHTML, 'text/html');
		const alertElement = alertDoc.querySelector('[data-js-alert]');

		if (!alertElement) return;

		this.elNode.innerHTML = alertHTML;

		modalFactory();

		if (cb && typeof cb === 'function') {
			cb();
		}
	}

	onCloseClick(event) {
		event.preventDefault();

		this.storage.setItem(this.config.localStorage.key, this.time);

		this.close();

		this.elCloseButton?.blur();
	}

	close() {
		this.elAlert?.classList.remove('alert--visible');
		this.elAlert?.setAttribute('inert', '');
	}

	open() {
		this.elAlert?.classList.add('alert--visible');
		this.elAlert?.removeAttribute('inert');
	}

	bindUI() {
		this.elCloseButton?.addEventListener('click', this.onCloseClick.bind(this));
	}

	setup() {
		this.elAlert?.classList.toggle('alert--enabled', true);

		if (this.storageValue !== this.time) {
			this.open();

			return;
		}

		this.close();
	}

	onReady() {
		this.setup();
		this.bindUI();
	}

	init() {
		if (this.ajaxURL) {
			this.fetchMarkupViaAjax(this.onReady.bind(this));

			return;
		}

		this.onReady();
	}
}

export default function factory(selector = DEFAULT_SELECTOR, settings = {}) {
	let node = document.querySelector(selector);

	if (!node) return;

	let config = nodeConfig(node, NAMESPACE, settings, DEFAULT_SETTINGS);
	let module = new Alert(node, config);

	module.init();

	return module;
}
